<template>
    <div style="width: 100%" class="clearfix">
        <div style="float: left">
        <el-input-number
            v-model="minVal" 
            size="small" 
            :controls="false"
            :step="stepValue"
            :min="minValue"
            :max="maxValue"
            @change="onMinChanged">
        </el-input-number>
        </div>
        <div style="width: 40%; float: left; margin: 0 20px">
            <el-slider
                range
                v-model="bindValue"
                :min="minValue"
                :max="maxValue"
                :step="stepValue"
                @change="onSliderChanged">
            </el-slider>
        </div>
        <div style="float: left">
            <el-input-number 
                v-model="maxVal" 
                size="small" 
                :controls="false"
                :step="stepValue"
                :min="minValue"
                :max="maxValue"
                @change="onMaxChanged">
            </el-input-number>
        </div>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        config: Object,
        value :Array,
    },
    data() {
        return {
            bindValue: [],
            minVal: 0,
            maxVal: 100,
        }
    },
    mounted() {
        this.minVal = this.minValue;
        this.maxVal = this.maxValue;
        
        if(this.value)   {
            this.bindValue  = this.value;
             this.minVal  = this.bindValue[0];
             this.maxVal  = this.bindValue[1];
        } 
        else{
           this.bindValue = [this.minVal, this.maxVal];
        }
    },
    methods: {
        onMinChanged(val) {
            if(val > this.maxVal) {
                this.minVal = this.maxVal;
                this.maxVal = val;
            } else {
                this.minVal = val;
            }
            this.bindValue = [this.minVal, this.maxVal];
            this.$emit('change', this.bindValue);
            
        },
        onMaxChanged(val) {
            if(val < this.minVal) {
                this.maxVal = this.minVal;
                this.minVal = val;
            } else {
                this.maxVal = val;
            }
            this.bindValue = [this.minVal, this.maxVal];
            this.$emit('change', this.bindValue);
        },
        onSliderChanged(val) {
            if(!isNaN(val[0]) && !isNaN(val[1])) {
                this.minVal = val[0];
                this.maxVal = val[1];
            }    
          
            this.$emit('change', this.bindValue);
        },
    },
    computed: {
        minValue() {
            return this.config && this.config.min || 0;
        },
        maxValue() {
            return this.config && this.config.max || 100;
        },
        stepValue() {
            return this.config && this.config.step || 1;
        },

     
        
    },
   
}
</script>
